import { render, staticRenderFns } from "./StatusOverlay.vue?vue&type=template&id=f08f3a40&scoped=true"
import script from "./StatusOverlay.vue?vue&type=script&lang=js"
export * from "./StatusOverlay.vue?vue&type=script&lang=js"
import style0 from "./StatusOverlay.vue?vue&type=style&index=0&id=f08f3a40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08f3a40",
  null
  
)

export default component.exports